
import {
  defineComponent,
  onMounted,
  watch,
  computed,
  ref,
  watchEffect,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import VPagination from "@hennge/vue3-pagination";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AppService from "@/core/services/AppService";
export default defineComponent({
  name: "account-list",
  components: { VPagination },
  props: {
    page: {
      type: String,
      default: "1",
    },
    limit: {
      type: String,
      default: "20",
    },
    email: {
      type: String,
      default: "",
    },
    order: {
      type: String,
      default: "desc",
    },
    order_by: {
      type: String,
      default: "name",
    },
    search: {
      type: String,
      default: "{}",
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    let params = {
      page: parseInt(props.page),
      limit: parseInt(props.limit),
      email: props.email,
      order: props.order,
      order_by: props.order_by,
      search: props.search,
    };
    const s_email = ref();
    const s_name = ref();
    const limitData = [5, 10, 20, 50, 100];
    const action_get_data = "GET_ACCOUNTS_DATA";
    store.dispatch(action_get_data, AppService.convertParams(params));

    const listData = computed(() => store.getters["listDataAccounts"]);
    const totalPages = computed(() => store.getters["getAccountPages"]);
    const totalDocs = computed(() => store.getters["getTotalAccounts"]);
    const roleUser = computed(() => store.getters["getRoleUser"]);
    const onChangePage = async (next_page) => {
      params.page = next_page;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "accounts"
      );
    };
    watch(props, (selection, prevSelection) => {
      /* ... */
      //console.log("watch:", selection, prevSelection);
    });
    const onChangeLimit = async (event) => {
      let positionMax =
        params.limit * params.page > totalDocs.value
          ? totalDocs.value
          : params.limit * params.page;
      params.limit = event.target.value;
      params.page =
        Math.ceil(positionMax / params.limit) > 0
          ? Math.ceil(positionMax / params.limit)
          : 1;
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "accounts"
      );
    };
    const onClickSort = async (order_by) => {
      params.order_by = order_by;
      params.order = params.order === "desc" ? "asc" : "desc";
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "accounts"
      );
    };
    const onSearch = async () => {
      let searchObject = {};
      if (s_name.value != "") {
        searchObject["name"] = s_name.value;
      }
      if (s_email.value != "") {
        searchObject["email"] = s_email.value;
      }
      params.search = JSON.stringify(searchObject);
      await AppService.getDataListObject(
        params,
        store,
        router,
        action_get_data,
        "accounts"
      );
    };
    const onClickDelete = (id) => {
      Swal.fire({
        text: "Bạn chắc chắn muốn xóa chứ ?",
        icon: "warning",
        buttonsStyling: false,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        customClass: {
          confirmButton: "btn fw-bold btn-light-danger",
          cancelButton: "btn fw-bold btn-primary",
        },
      }).then(function (result) {
        let searchString = AppService.convertParams(params);
        if (result.isConfirmed) {
          store
            .dispatch("DELETE_ACCOUNT", { id, destroy: "true", searchString })
            .then(() => {
              Swal.fire({
                text: "Xóa thành công",
                icon: "success",
                buttonsStyling: false,
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  confirmButton: "btn fw-bold btn-light-success",
                  cancelButton: "btn fw-bold btn-light-primary",
                },
              }).then(function (result) {
                store.dispatch(
                  action_get_data,
                  AppService.convertParams(params)
                );
                // Go to page after successfully login
              });
            })
            .catch(() => {
              Swal.fire({
                text: store.getters.getErrors[0],
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Try again!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });
        }
      });
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Danh sách người dùng", ["Người dùng"]);
      //console.log("On Mounted");
      MenuComponent.reinitialization();
      let searchObject = JSON.parse(params.search);
      s_email.value = searchObject.email;
      s_name.value = searchObject.name;
    });
    return {
      s_email,
      s_name,
      listData,
      params,
      limitData,
      totalDocs,
      totalPages,
      roleUser,
      onChangePage,
      onClickDelete,
      onChangeLimit,
      onClickSort,
      onSearch,
    };
  },
});
